import http from '../utils/http'


// 个人信息
export function userDetailApi(){
    return http.get('detailUser')
}